import React from 'react';
import '../svg.css';


const BathFixture = props => {
    const { fill } = props;
    return (
        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36"
            height="36px"
            width="36px"
            className='svg'
        >

            <g id="Logo"><rect id="frame" className="bathFixture-1" width="36" height="36" rx="10" /></g><g className="bathFixture-2"><path className="bathFixture-3" d="M26.28,17.17h-14v-6a.56.56,0,0,1,.55-.56h.82a.55.55,0,0,1,.51.34,1.46,1.46,0,0,0-1.21,1.44v.54a.51.51,0,0,0,.51.51H16a.51.51,0,0,0,.51-.51v-.54a1.47,1.47,0,0,0-1.27-1.45,1.58,1.58,0,0,0-1.57-1.36H12.8a1.59,1.59,0,0,0-1.58,1.59v6H9.72a.52.52,0,0,0-.52.52v1.72a.53.53,0,0,0,.4.51H26.4a.53.53,0,0,0,.4-.51V17.69A.52.52,0,0,0,26.28,17.17Z" /></g><path className="bathFixture-3" d="M9.94,21v1.92A2.9,2.9,0,0,0,12,25.66v.25a.51.51,0,0,0,.51.52H14a.52.52,0,0,0,.52-.52v-.13h6.94v.13a.52.52,0,0,0,.52.52h1.47a.51.51,0,0,0,.51-.52v-.25a2.9,2.9,0,0,0,2.09-2.79V21Z" />

        </svg>
    );
};

export default BathFixture;
